import { render, staticRenderFns } from "./ListaServiceCenters.vue?vue&type=template&id=692b2d74"
import script from "./ListaServiceCenters.vue?vue&type=script&lang=js"
export * from "./ListaServiceCenters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports